<template>
  <ul class="nav user-menu">
    <li :class="{ active: isActive(profileHref) }">
      <a
        :href="profileHref"
        class="nav-link nav-item active router-link-active simple-text"
      >
        <i class="md-icon md-icon-font md-theme-default">account_circle</i>
        <p>
          {{
            organization.primaryContact.firstName +
              " " +
              organization.primaryContact.lastName
          }}
          <span class="sidebar-aside">Edit Profile</span>
        </p>
      </a>
    </li>
  </ul>
</template>
<script>
export default {
  data() {
    return {
      profileHref: "#/profile"
    };
  },
  props: {
    organization: {}
  },
  methods: {
    /*
    TODO: Consider moving this somewhere global as it will
    be useful in other places (specifically the MobileMenu
    will need it). The SideBarItem.vue (plugin class) has
    an implementation similar to this, but we are not using
    `SideBarItems` here (because the sidebar is only structured
    to have one sidebar, not multiple, VMD does the user menu
    and mobile menu with straight up lists, but this meant a
    bunch of the sidebar functionality did not work properly
    for these other menus).
    */
    isActive(link) {
      if (link.startsWith("#")) {
        link = link.substring(1);
      }

      if (this.$route && this.$route.path) {
        return this.$route.path === link;
      }
      return false;
    }
  }
};
</script>
<style type="scss" scoped>
.sidebar .nav.user-menu {
  margin: 5px 0;
}
.sidebar .nav.user-menu p {
  font-weight:bold;
}
</style>
